import { APP_STATUS_STORE_KEY } from './appStatus.constants';

export const selectAppStatus = (state) => (state.keyValueStore[APP_STATUS_STORE_KEY]);
